export const blockIconsHomeRollerShadesClosed = (
	<span className='material-symbols-outlined'>roller_shades_closed</span>
);
